import ProjectsProxy from '@/proxies/Projects';
import * as types from './mutation-types';
import {
  ENGINE_STATUS_LOADING,
  ENGINE_STATUS_STOPPED,
  VIDEO_TV_TYPE,
} from '@/constants';

export default {
  copyProject({ dispatch, commit, getters, rootGetters }, payload) {
    const info = payload?.match || {};
    const teamA = info?.team_a || {};
    const teamB = info?.team_b || {};
    const fileId = payload.video[0].id;
    const fileIdTv = info.video_tv?._id;

    [fileId, fileIdTv].forEach(id => {
      if (!id) {
        return;
      }
      const file = rootGetters['files/items'].find(el => el.id === id);
      if (!file) {
        dispatch('files/getItem', id, { root: true });
      }
    });

    const videos = [...getters.linkedVideo, {
      file_id: fileId,
      type: getters.type,
    }];


    if (!!info?.video_tv) {
      videos.push({
        file_id: fileIdTv,
        type: VIDEO_TV_TYPE,
      });
    }

    const options = {
      game_date: info?.date,
      referee_outfit_id: info?.referee_kit,
      team_a_id: teamA.id,
      team_a_gk_outfit_id: teamA.goalkeeper_kit,
      team_a_outfit_id: teamA.player_kit,
      team_a_players: teamA.predefinedPlayers,
      team_a_scheme: teamA.scheme,
      team_b_id: teamB.id,
      team_b_gk_outfit_id: teamB.goalkeeper_kit,
      team_b_outfit_id: teamB.player_kit,
      team_b_players: teamB.predefinedPlayers,
      team_b_scheme: teamB.scheme,
      venue_id: info?.venue?.id,
    }

    commit(types.LINK_VIDEO, videos);
    commit(types.ADD_OPTIONS, options);
    commit(types.SET_STATE, 2);
  },

  next({ commit }) {
    commit(types.INC_STATE);
  },

  start({ commit }) {
    commit(types.SET_STATE, 1);
  },

  cancel({ commit, dispatch, getters }) {
    if (getters.state === 1.1) {
      commit(types.SET_STATE, 1);
    } else {
      dispatch('reset')
    };
  },

  reset({ commit }) {
    commit(types.RESET);
  },

  setActiveCamera({ commit }, payload) {
    commit(types.SET_ACTIVE_CAMERA, payload);
  },

  clearActiveCamera({ commit }) {
    commit(types.CLEAR_ACTIVE_CAMERA);
  },

  setLinkedTvVideo({ commit }, payload) {
    commit(types.LINK_TV_VIDEO, payload);
  },

  setLinkedVideo({ commit, getters, rootGetters }, payload) {
    const video = rootGetters['files/items'].find(({ id }) => id === payload);
    const result = [...getters.linkedVideo, {
      file_id: video.id,
      hash: video.hash,
      type: getters.type,
    }];
    commit(types.LINK_VIDEO, result);
    commit(types.SET_STATE, 1);
  },

  removeLinkedVideo({ commit }, payload) {
    commit(types.UNLINK_VIDEO, payload);
  },

  addOptions({ commit }, payload) {
    commit(types.ADD_OPTIONS, payload);
  },

  setStateStep({ commit }, payload) {
    commit(types.SET_STATE, payload);
  },

  setVideoType({ commit, getters }, payload) {
    if (getters.type !== payload) {
      commit(types.SET_VIDEO_TYPE, payload);
    }
  },

  async submit({ commit, getters, rootGetters, dispatch }) {
    commit(types.SET_LOADING, true);
    const proxy = new ProjectsProxy();
    const rpcServerStatus = rootGetters['usage/rpcServerRunning'];
    const options = {
      ...getters.defaults,
      ...getters.options,
      files: getters.linkedVideo.map(({ file_id, type }) => ({
        file_id,
        file_type: type,
      })),
    };
    try {
      if (rpcServerStatus === ENGINE_STATUS_STOPPED) {
        dispatch('usage/changeEngineStatus', ENGINE_STATUS_LOADING, { root: true });
      }
      await proxy.create(options);
      await dispatch('projects/refresh', null, { root: true });
      dispatch('usage/getEngineStatus', null, { root: true });
      dispatch('notification/success', 'confirmationmessage.project_created', { root: true });
    } catch (e) {
      dispatch('notification/error', 'errormessage.failed_to_create_project', { root: true });
    } finally {
      commit(types.SET_LOADING, false);
      dispatch('reset');
    }
  },
  async update({ getters, dispatch }, payload) {
    const { data = {}, id } = payload;
    const proxy = new ProjectsProxy();
    const options = { ...getters.options, ...data };
    try {
      const response = await proxy.update(id, options);
      await dispatch('projects/refreshProject', response, { root: true });
      dispatch('notification/success', 'confirmationmessage.project_changed', { root: true });
    } catch (e) {
      dispatch('notification/error', 'errormessage.failed_to_change_project', { root: true });
    } finally {
      dispatch('reset');
    }
  },
};
